module.exports = __webpack_public_path__ + "img/1560191334.a4ff732c.jpg";